import { Injectable } from '@angular/core';
import {ApiService} from "./api.service";
import {NavigationSection} from "../models/Navigation/NavigationSection";

@Injectable({
  providedIn: 'root'
})
export class MenuNavigationService {

  menu: NavigationSection[] = [
    {
      admin: false,
      requireOnboard: true,
      title: "Fundraising",
      items: [
        {
          title: 'Dashboard',
          icon: 'menuicon-dashboard',
          icon_type: 'font',
          url: '/dashboard'
        },
        {
          title: 'Campaigns',
          icon: 'menuicon-campaign',
          icon_type: 'font',
          url: '/campaigns'
        },
        {
          title: 'Donations',
          icon: 'menuicon-heart-1',
          icon_type: 'font',
          url: '/donations'
        },
        {
          title: 'Donors',
          icon: 'menuicon-success-1',
          icon_type: 'font',
          url: '/donors'
        }
      ]
    },
    {
      admin: false,
      requireOnboard: true,
      title: "Events",
      items: [
        {
          title: 'Events',
          icon: 'fi fi-br-calendar',
          icon_type: 'font',
          url: '/events'
        }
      ]
    },
    {
      admin: false,
      requireOnboard: true,
      title: "Back Office",
      items: [
        {
          title: 'Finance',
          icon: 'menuicon-accounting',
          icon_type: 'font',
          url: '/finance'
        }
      ]
    },
    {
      admin: true,
      requireOnboard: false,
      title: 'Settings',
      items: [
        {
          title: 'Charity Brands',
          icon: 'menuicon-graphic-design',
          icon_type: 'font',
          url: '/admin/brands'
        },
        {
          title: 'Billing',
          icon: 'menuicon-credit-card',
          icon_type: 'font',
          url: '/admin/billing'
        },
        {
          title: 'Users',
          icon: 'fi fi-br-users-alt',
          icon_type: 'font',
          url: '/admin/users'
        },
      ]
    },
  ];

  constructor(public api: ApiService) { }

}
